import "./index.less";
import AppIcon from "@/assets/common/app_icon.png";
import CloseIcon from "@/assets/common/ic_close.svg";

interface ExpireProps {
  visible: boolean;
  onClose: () => void;
  onSave?: () => void;
  saving: boolean;
}

export default function WebExpire(props: ExpireProps) {
  const { visible, onClose, onSave, saving } = props;

  const handleSave = () => {
    if (saving) return;
    onSave?.();
  };

  return (
    <>
      {visible && (
        <div className="web-expire">
          <img className="app-icon" src={AppIcon} />
          会议平板文件链接7天内有效，保存至AI会记可永久编辑查阅
          <div className={`save-btn ${saving ? "opacity-30" : ""}`} onClick={handleSave}>
            保存至AI会记
          </div>
          <img onClick={() => onClose()} className="close-icon" src={CloseIcon} />
        </div>
      )}
    </>
  );
}
